<section class="tc-exec-stats" aria-labelledby="tc-exec-stats-heading">
  <h3 id="tc-exec-stats-heading" class="tc-exec-stats__title">
    {{ 'testCases.form.executionStats.blockTitle' | translate }}
  </h3>

  @if (error()) {
    <p class="tc-exec-stats__empty" role="alert">
      {{ 'testCases.form.executionStats.loadError' | translate }}
    </p>
  } @else if (hasData()) {
    <div class="tc-exec-stats__body">
      <div
        class="tc-exec-stats__donut"
        role="img"
        [style.background]="donutBackground()"
        [attr.aria-label]="'testCases.form.executionStats.ariaLabel' | translate: ariaParams()"
      >
        <div class="tc-exec-stats__hole" aria-hidden="true">
          <div class="tc-exec-stats__hole-text">
            <span class="tc-exec-stats__rate">{{ stats()!.passRate }}%</span>
            <span class="tc-exec-stats__rate-label">
              {{ 'testCases.form.executionStats.passRate' | translate }}
            </span>
          </div>
        </div>
      </div>

      <ul class="tc-exec-stats__legend">
        @for (item of legend; track item.key) {
          <li class="tc-exec-stats__legend-item">
            <span class="tc-exec-stats__dot tc-exec-stats__dot--{{ item.modifier }}" aria-hidden="true"></span>
            <span class="tc-exec-stats__legend-label">{{ item.labelKey | translate }}</span>
            <span class="tc-exec-stats__legend-value">{{ legendValue(item) }}</span>
          </li>
        }
      </ul>
    </div>
  } @else if (!loading()) {
    <p class="tc-exec-stats__empty">
      {{ 'testCases.form.executionStats.empty' | translate }}
    </p>
  }
</section>
